var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInactiveToggle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "19px",
    viewBox: "0 0 32 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7AB1908C-D3A7-4E11-AE03-6CD734332C21") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings-and-Preferences",
    transform: "translate(-929.000000, -474.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Inactive-Toggle",
    transform: "translate(929.751326, 474.635471)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CFCFCF",
    x: 0,
    y: 0,
    width: 30.8125,
    height: 18.0625,
    rx: 9.03125
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 9.10414611,
    cy: 9.03125,
    r: 7.97713026
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveToggle);
export default __webpack_public_path__ + "static/media/InactiveToggle.1917d2e76eca088ed369342488f08c10.svg";
export { ForwardRef as ReactComponent };